"use client";

import { useState } from "react";
import {
  UserCircleIcon,
  PhotographIcon,
  HashtagIcon,
  CreditCardIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/outline";
import { Orders } from "@/components/ProfilePage/Orders";
import Designs from "@/components/ProfilePage/Designs";
import LogoutButton from "@/components/ProfilePage/LogoutButton";
import withState from "@/hocs/withState";
import { CheckoutProvider } from "@/hooks/useCheckout";
import { ProfileDetails } from "@/components/ProfilePage/ProfileDetails";
import ProfileAddressSection from "@/components/ProfilePage/ProfileAddressSection";
import PaymentForm from "./checkout/payment/PaymentForm";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ProfilePageContent = () => {
  const [currentTab, setCurrentTab] = useState("orders");

  return (
    <div>
      <main className="relative mt-8">
        <div className="max-w-6xl px-4 pb-6 mx-auto sm:px-6 lg:px-8 lg:pb-16">
          <div className="bg-white rounded-lg shadow">
            <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
              <aside className="py-6 lg:col-span-2">
                <nav className="space-y-1">
                  <button
                    onClick={() => setCurrentTab("orders")}
                    className={classNames(
                      currentTab === "orders"
                        ? "bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                      "w-full group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                    )}
                    aria-current={currentTab === "orders" ? "page" : undefined}
                  >
                    <HashtagIcon
                      className={classNames(
                        currentTab === "orders"
                          ? "text-blue-500 group-hover:text-blue-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="capitalize truncate">orders</span>
                  </button>
                  <button
                    onClick={() => setCurrentTab("designs")}
                    className={classNames(
                      currentTab === "designs"
                        ? "bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                      "w-full group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                    )}
                    aria-current={currentTab === "designs" ? "page" : undefined}
                  >
                    <PhotographIcon
                      className={classNames(
                        currentTab === "designs"
                          ? "text-blue-500 group-hover:text-blue-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="capitalize truncate">designs</span>
                  </button>
                  <button
                    onClick={() => setCurrentTab("profile")}
                    className={classNames(
                      currentTab === "profile"
                        ? "bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                      "w-full group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                    )}
                    aria-current={currentTab === "profile" ? "page" : undefined}
                  >
                    <UserCircleIcon
                      className={classNames(
                        currentTab === "profile"
                          ? "text-blue-500 group-hover:text-blue-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="capitalize truncate">profile</span>
                  </button>
                  <button
                    onClick={() => setCurrentTab("shipping")}
                    className={classNames(
                      currentTab === "shipping"
                        ? "bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                      "w-full group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                    )}
                    aria-current={currentTab === "shipping" ? "page" : undefined}
                  >
                    <PaperAirplaneIcon
                      className={classNames(
                        currentTab === "shipping"
                          ? "text-blue-500 group-hover:text-blue-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="capitalize truncate">Delivery Addresses</span>
                  </button>

                  <button
                    onClick={() => setCurrentTab("payment")}
                    className={classNames(
                      currentTab === "payment"
                        ? "bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                      "w-full group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                    )}
                    aria-current={currentTab === "payment" ? "page" : undefined}
                  >
                    <CreditCardIcon
                      className={classNames(
                        currentTab === "payment"
                          ? "text-blue-500 group-hover:text-blue-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    <span className="capitalize truncate">Payment Cards</span>
                  </button>
                  <LogoutButton />
                </nav>
              </aside>

              {currentTab === "profile" && <ProfileDetails />}

              {currentTab === "orders" && (
                <div className="flex justify-center w-full text-lg text-center text-gray-500 lg:col-span-10">
                  <Orders />
                </div>
              )}

              {currentTab === "designs" && (
                <div className="flex justify-center w-full text-lg text-center text-gray-500 lg:col-span-10">
                  <Designs />
                </div>
              )}

              {currentTab === "shipping" && (
                <div className="w-full p-4 lg:col-span-10 lg:py-12 lg:px-8">
                  <ProfileAddressSection />
                </div>
              )}
              {currentTab === "payment" && (
                <div className="w-full p-4 lg:col-span-10 lg:py-12 lg:px-8">
                  <CheckoutProvider>
                    <PaymentForm title="Payment Method" />
                  </CheckoutProvider>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export const ProfilePage = withState(ProfilePageContent);
